import React from "react";
import Slider from "../components/Tokenization/Slider";
import HeadingSample from "../components/utility/headingSample";
import PieChartSteps from "../components/Tokenization/chartPie";
import TokenUtilityTable from "../components/Tokenization/tokenUtilitytable";

const Slider_imgs = [
    "/tokenization/slide1.png",
    "/tokenization/slide2.svg",
    "/tokenization/slide3.svg",
];
const Tokenization: React.FC = () => {
    // -------------sec1setting------
    const sec1Subtitle = "";
    const sec1Title = [
        "tokenization",
        "#F8D835",
    ];


    return (
        <div className="w-full  flex flex-col items-center justify-center bg-white box-border overflow-hidden">

            {/* ------------section1----------- */}
            <div id="tokenization_home" className="h-[700px] w-[100vw]  bg-[url('../public/tokenization/section1.svg')] inset-0  bg-black/30  bg-blend-overlay  bg-cover bg-center ">
                <HeadingSample subtitle={sec1Subtitle} title={sec1Title} />
            </div>
            {/* -----------section2-------- */}
            <Slider images={Slider_imgs} />

            {/* --------------section3------ */}
            {/* ----------section4---------- */}

            <div id="tokenization_DualToken" className="w-full h-auto bg-[#3F5BB6] flex flex-col justify-center  items-center lg:items-start p-2 pt-6 sm:p-10 gap-4">
                <div className="w-full  flex flex-col justify-center items-start text-left">
                    <div className="border-l-2 border-[#F8D835] px-2 text-[#F8D835] font-bold text-[22px] sm:text-[36px] font-bungeeinline uppercase">
                        Two-Phase Approach - Dual Token Strategy
                    </div>
                    <div className="font-bold text-[#FF8533] font-bungeeinline text-xl sm:text-3xl lg:text-5xl py-4 sm:py-6  uppercase">
                        Mineralex Group implement a dual token strategy aiming to create a secure and accessible investment framework
                    </div>
                </div>
                <div className="w-full   h-auto">
                    <img src="/tokenization/section4.svg" alt="section4" className="w-full max-w-xl  h-auto mx-auto" />
                </div>
            </div>

            {/* ----------section5---------- */}
            <div id="tokenization_utilityToken" className="w-full  h-auto">
                <div id="plannedTokens" className="w-full flex flex-col justify-center items-center p-2 md:p-8 mb-8 lg:p-10">
                    <div
                        className="contain w-full h-auto flex flex-col items-start justify-center gap-6 md:gap-8  sm:p-10 z-30 relative"
                    >
                        <div className="border-l-4 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[23px] lg:text-5xl font-bungeeinline">
                            The planned Utility Token (MXUT)
                        </div>
                        <div className="text-black text-2xl lg:text-3xl font-bold flex flex-col items-start">
                            Purpose
                        </div>
                        <div className="text-black text-lg sm:text-xl lg:text-2xl flex flex-col items-start">
                            The MXUT token will be the backbone of the Mineralex ecosystem’s community participation and reward mechanisms. It powers:
                        </div>
                    </div>
                    <div className="max-w-6xl flex flex-col gap-8 justify-center items-center shadow-lg rounded-2xl sm:p-6 z-0">
                        <div
                            className="w-full h-full">
                            <img src="/tokenization/sec5_utilityToken_MXUT.png" alt="sec5_utilityToken_MXUT" className="w-full max-w-2xl mx-auto h-auto" />
                        </div>
                        <div
                            className="w-full max-w-7xl text-center text-black text-lg sm:text-xl flex flex-col items-start">
                            The MXUT token will be designed as a non-financial utility token, ensuring that its primary function is to enhance the user experience and facilitate community-driven governance within the Mineralex ecosystem.
                        </div>
                    </div>
                </div>
                <div className="w-full bg-[#F5F5F5] flex flex-col justify-center items-center pt-2 md:pt-8 lg:pt-10 relative ">
                    {/* <img src="/tokenization/utility_token_bg.png" alt="utility_token_bg" className="bg-blue-50"/> */}
                    <div className="w-full text-start text-black text-2xl lg:text-3xl font-bold flex flex-col items-start p-4 sm:p-6 lg:pt-12">
                        The planned Utility Token Economics
                    </div>
                    <div className="w-full text-start text-black text-lg sm:text-xl lg:text-2xl flex flex-col items-start">
                        Mineralex has prepared a preliminary ecosystem draft that will be finalized and fully disclosed in due course.
                        <br />Please note that the key details outlined below are tentative and may be adjusted before the final release.
                    </div>
                    <div className="w-full lg:w-3/4 p-2 sm:p-8 m-auto">
                        <PieChartSteps />
                    </div>
                    <div
                        className="w-full max-w-7xl text-center text-[#172B6B] text-xl font-bold lg:text-2xl flex flex-col items-start">
                        <div className="p-4">
                            MXUT Investment Rounds
                        </div>
                        <img src="/tokenization/MXUT_investment_Rounds.png" alt="MXUT_investment_Rounds" className="w-full max-w-3xl sm:aspect-video h-auto mx-auto shadow-xl rounded-2xl" />

                    </div>

                    <div
                        className="w-full max-w-7xl text-xl  flex flex-col items-start p-4">
                        <div className="w-full text-start text-[#172B6B] text-xl sm:text-2xl lg:text-3xl font-bold p-6">
                            Planned Utility Token Holder Rights
                        </div>
                        <div className="w-full text-start text-black text-lg sm:text-xl lg:text-2xl flex flex-col items-start">
                            <div>
                                All rights and benefits presented here are tentative and may be adjusted before the final release.
                            </div>
                            <div>
                                <span className="font-bold">Buyback Mechanism</span>: 25 % of quarterly ecosystem revenues allocated for token buybacks and burns (or strategic lock-ups)
                            </div>
                            <div>
                                <span className="font-bold"> Asset-Backed Growth</span>: Sustainable ecosystem expansion underpinned by over USD 10 billion in mineral resource valuations
                            </div>
                        </div>
                        <div className="w-full max-w-2xl flex flex-col items-center justify-center mx-auto py-4">
                            <div className="w-full flex flex-col items-center justify-center md:gap-4 ">
                                <div className="w-full text-center text-blue-600 text-base sm:text-xl lg:text-2xl font-bold font-montserrat">
                                    Prioritize Strategies
                                </div>
                                <div className="w-full text-center text-blue-500 text-base sm:text-xl font-montserrat">
                                    Set staking rates and approve ecosystem upgrades
                                </div>
                            </div>
                            <div className="w-full flex flex-row justify-center items-center">
                                <div className="w-full flex flex-col items-center justify-center md:gap-4">
                                    <div className="w-full text-center text-blue-600 text-base sm:text-xl lg:text-2xl font-bold font-montserrat">
                                        Allocate funds
                                    </div>
                                    <div className="w-full text-center text-blue-500 text-sm sm:text-base font-montserrat">
                                        Decide how to distribute funds for ecosystem development
                                    </div>
                                </div>
                                <div
                                    className="w-full">
                                    <img src="/tokenization/governance_Voting.png" alt="governance_Voting" className="w-full max-w-3xl h-auto mx-auto" />
                                </div>
                                <div className="w-full flex flex-col items-center justify-center md:gap-4">
                                    <div className="w-full text-center text-orange-400 text-base sm:text-xl lg:text-2xl font-bold font-montserrat">
                                        Develop RWA project
                                    </div>
                                    <div className="w-full text-center text-orange-400 text-sm sm:text-base font-montserrat">
                                        Make decisions on real the Real-World Assert project development
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               

                    <div
                        className="w-full max-w-7xl text-center text-black text-xl font-bold lg:text-2xl flex flex-col items-start ">
                        <div className="w-full p-4 text-start">
                            Discounted Access & Fees
                        </div>

                        <TokenUtilityTable />
                    </div>

                    <div
                        className="w-full max-w-7xl text-center text-black text-xl font-bold lg:text-2xl flex flex-col items-start ">
                        <div className="p-4">
                            Staking Models
                        </div>
                        <img src="/tokenization/staking_Models.png" alt="stakin_Models" className="w-full max-w-2xl h-auto mx-auto" />
                    </div>
                    <div className="w-full max-w-7xl h-full grid grid-cols-1 lg:grid-cols-3 justify-center items-start gap-4 py-6">
                        <div
                            className="h-full max-w-xl  flex flex-col items-start p-4 sm:p-6 shadow-2xl rounded-xl bg-yellow-100">
                            <div className="w-full text-start text-black text-xl font-bold p-6">
                                Community Incentives
                            </div>
                            <div className="w-full text-start text-black text-lg flex flex-col items-start gap-4">
                                <li>
                                    Special Airdrops: Token holders may receive special airdrops as part of community engagement efforts.
                                </li>
                                <li>
                                    Surprise Rewards: Random rewards will be distributed to recognize and appreciate top contributors within the community.
                                </li>
                                <li>
                                    Recognition for Top Contributors: Acknowledgment will be given to those who significantly contribute to the ecosystem's growth and success.
                                </li>
                            </div>
                        </div>

                        <div
                            className="h-full max-w-xl  flex flex-col items-start p-4 sm:p-6 shadow-2xl rounded-xl bg-yellow-100">
                            <div className="w-full text-start text-[#172B6B] text-xl  font-bold p-2">
                                MXUT Planned Technology & Legal Infrastructure
                            </div>
                            <div className="w-full text-start text-black text-lg flex flex-col items-start gap-4">
                                <div>
                                    <span className="font-bold">Blockchain Architecture</span> - Solana SPL tokens.
                                </div>
                                <div>
                                    <span className="font-bold"> Custody and Tokenization</span>- Gold Vaults: Custodians at the decided jurisdiction; monthly third-party audits
                                </div>
                                <div>
                                    <span className="font-bold"> Legal Framework</span> - Jurisdiction: TBD, Regulations: MiCA Compliance
                                </div>
                                <div>
                                    <span className="font-bold"> Compliance Stack</span>  - AML/KYC
                                </div>
                                <div>
                                    <span className="font-bold"> Transition to Decentralization</span>: Gradual implementation of advanced decentralized governance mechanisms
                                </div>
                            </div>
                        </div>

                        <div
                            className="h-full max-w-xl  flex flex-col items-start p-4 sm:p-6 shadow-2xl rounded-xl bg-yellow-100">
                            <div className="w-full text-start text-black text-xl font-bold p-6">
                                ESG Commitment
                            </div>
                            <div className="w-full text-start text-black text-lg flex flex-col items-start gap-4">
                                <li>
                                    Emphasis on sustainable mining practices
                                </li>
                                <li>
                                    Clear reporting of environmental impact metrics
                                </li>
                                <li>
                                    Social responsibility initiatives benefiting local communities where Mineralex operates
                                </li>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="w-full h-auto bg-yellow-100 flex flex-col justify-center items-center p-2 py-6">
                    <div className="w-full text-start border-l-4 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[23px] lg:text-5xl font-bungeeinline p-4">
                        The planned RWA Token (MXRWA)
                    </div>
                    <div className="w-full max-w-7xl h-auto flex flex-col md:flex-row justify-center items-center">
                        <div
                            className="contain w-full h-auto flex flex-col items-start justify-center gap-6 md:gap-8  sm:p-10 z-30 p-4"
                        >
                            <div className="text-black text-2xl lg:text-3xl font-bold flex flex-col items-start px-4">
                                Purpose
                            </div>
                            <div className="text-black text-lg sm:text-xl lg:text-2xl flex flex-col items-start">
                                The Mineralex RWA Token is planned to grant fractional ownership of mineral assets and dividend rights.
                            </div>
                            <div className="text-black text-2xl lg:text-3xl font-bold flex flex-col items-start px-4">
                                Raise target
                            </div>
                            <div className="text-black text-lg sm:text-xl lg:text-2xl flex flex-col items-start">
                                Raise $200M through the RWA Token to fund exploration, two large scale mining mining operations, mergers & acquisitions, and operational expenses.
                            </div>

                            <div
                                className="w-full max-w-7xl text-xl  flex flex-col items-start ">
                                <div className="w-full text-start text-black text-2xl lg:text-3xl font-bold p-2">
                                    Dividends, Growth and Operations
                                </div>
                                <div className="w-full text-start text-black text-lg sm:text-xl lg:text-2xl flex flex-col items-start gap-4">
                                    <div>
                                        <span className="font-bold">Non-Gold Minerals mining in Sierra Leone</span>: Unlocking a verified $5B Coltan resource as well as, Tin, and REE mining are planned to be used for:
                                    </div>
                                    <li>
                                        50% reinvested into gold exploration and acquisitions to stabilize MXRWA value and growth.
                                    </li>
                                    <li>
                                        50% are used for dividends and operations.
                                    </li>
                                </div>
                            </div>
                        </div>

                        <div
                            className="w-full max-w-7xl text-xl  flex flex-col items-start p-4">
                            <div className="w-full text-start text-black text-2xl lg:text-3xl font-bold p-2 py-6">
                                The Value Proposition of MXRWA Token
                            </div>
                            <img src="/tokenization/planned_RWA.png" alt="planned_RWA" className="w-full max-w-72 mx-auto rounded-full p-4" />
                            <div className="w-full text-start text-black text-lg sm:text-xl lg:text-2xl flex flex-col items-start gap-4">
                                <span className="font-bold">Large Scale Gold Mining Operation in Sierra Leone</span> : The MXRWA token is underpinned by verified gold mining operations in Sierra Leone, which unlock a substantial resource valued at approximately $5 billion.
                                <br />Each MXRWA token represents a fractional claim on these audited and bankable gold reserves, providing token holders with a direct link to a physical asset. This backing not only enhances the credibility of the token but also offers a hedge against market volatility, as gold has historically been a stable store of value, and provide a robust foundation for future growth.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Tokenization;